module.exports = __webpack_public_path__ + "29ff4724bd1b1e774a0195c2f9b1eaf2.woff2";